type ApiWarning = {
	code?: string;
	description?: string;
};

export const CUSTOMER_PHONE_DEDUP_WARNING_MESSAGE =
	"A contact with that phone number already exists and was used instead. The name was not changed.";

export function getCustomerPhoneDedupWarningMessage(warnings: ApiWarning[] = []): string {
	return warnings.some((candidate) => candidate.description === CUSTOMER_PHONE_DEDUP_WARNING_MESSAGE)
		? CUSTOMER_PHONE_DEDUP_WARNING_MESSAGE
		: "";
}
